module.exports = __webpack_public_path__ + "img/_logo-mastercard.1e54be80.svg";